module.exports = __webpack_public_path__ + "static/img/gold.635ebdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gold.png
// module id = iIpf
// module chunks = 1